import { useState } from 'react';
import { useNavigate, Link, useSearchParams } from 'react-router-dom';
import { Alert, Button, Card, CardBody, Form, FormGroup, Input, Label, Spinner } from 'reactstrap';
import { useAuth } from '../auth/useAuth.js';

export function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const [form, setForm] = useState({
    firstName: '',
    lastName: '',
    email: '',
    password: '',
    inviteCode: searchParams.get('code') ?? '',
  });
  const [error, setError] = useState(null);
  const [busy, setBusy] = useState(false);

  const update = (field) => (event) => setForm({ ...form, [field]: event.target.value });

  async function handleSubmit(event) {
    event.preventDefault();
    setBusy(true);
    setError(null);

    try {
      await register({ ...form, inviteCode: form.inviteCode.trim().toUpperCase() });
      navigate('/', { replace: true });
    } catch (err) {
      setError(err.message);
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="mx-auto" style={{ maxWidth: 480 }}>
      <h1 className="h3 mb-3">Create an account</h1>
      <Card>
        <CardBody>
          <Form onSubmit={handleSubmit}>
            {error && <Alert fade={false} color="danger">{error}</Alert>}

            <FormGroup>
              <Label for="inviteCode">Invite code</Label>
              <Input id="inviteCode" value={form.inviteCode} onChange={update('inviteCode')}
                placeholder="ABCD1234" required style={{ textTransform: 'uppercase' }} />
              <small className="text-muted">The league is invite-only. Ask an admin for a code.</small>
            </FormGroup>

            <div className="d-flex gap-3">
              <FormGroup className="flex-fill">
                <Label for="firstName">First name</Label>
                <Input id="firstName" value={form.firstName} onChange={update('firstName')} required />
              </FormGroup>
              <FormGroup className="flex-fill">
                <Label for="lastName">Last name</Label>
                <Input id="lastName" value={form.lastName} onChange={update('lastName')} required />
              </FormGroup>
            </div>

            <FormGroup>
              <Label for="reg-email">Email</Label>
              <Input id="reg-email" type="email" value={form.email} onChange={update('email')}
                autoComplete="username" required />
            </FormGroup>

            <FormGroup>
              <Label for="reg-password">Password</Label>
              <Input id="reg-password" type="password" value={form.password} onChange={update('password')}
                autoComplete="new-password" minLength={8} required />
              <small className="text-muted">
                At least 8 characters, including an uppercase letter and a digit.
              </small>
            </FormGroup>

            <Button color="primary" type="submit" disabled={busy} className="w-100">
              {busy ? <Spinner size="sm" /> : 'Create account'}
            </Button>
          </Form>
        </CardBody>
      </Card>
      <p className="text-muted mt-3 small">
        Already registered? <Link to="/login">Sign in</Link>.
      </p>
    </div>
  );
}
